// extracted by mini-css-extract-plugin
export var baseButton = "_wi-0";
export var controlsArrowKeys = "_wi-1";
export var controlsResetButton = "_wi-2";
export var lightGameButton = "_wi-4 _wi-0";
export var playAgainButton = "_wi-5 _wi-0";
export var startGameButton = "_wi-3 _wi-0";